export default __webpack_public_path__ + "static/media/P946_A_BD.bb79fc5a.pdf";